<template>
  <div id="app" v-cloak>
    <div v-if="state.page_type==1" class="page" :class=" 'btnColor' + state.user_type">
			<img class="page_bg" :src="pageBgUrl" alt="">
			<img class="ava" :src="state.avatar" alt="">
			<div class="arrow-rain" aria-hidden="true">
				<span></span>
				<span></span>
				<span></span>
			</div>
			<img @click="changePop" class="qrcode" :src="state.qr_code" alt="">


			<div class="p1">{{ state.time1 }}</div>
			<div class="p2">{{ state.time2 }}</div>

			<div class="p5">{{ state.tip }}</div>
			<div class="p6" @click="changePop2">【详情】</div>

			<div v-if="state.user_type==1" class="p3_1">{{ state.name }}</div>
			<div v-if="state.user_type==1" class="p4_1">{{ state.department }}</div>

			<div v-if="state.user_type==2" class="p3">{{ state.department }}</div>
			<div v-if="state.user_type==2" class="p4">{{ state.name }}</div>

			<div v-if="state.user_type==3" class="p3_3">{{ state.name }}</div>
			<div v-if="state.user_type==3" class="p4_3">{{ state.department }}</div>

			<!--		<div v-if="user_type==4" class="p3_4">{{}}</div>-->
			<div v-if="state.user_type==4" class="p4_4">{{ state.name }}</div>


		</div>
		<div v-if="state.page_type==2" class="page" :class=" 'btnColor' + state.user_type">
			<img class="page_bg_big" :src="pageBgUrl" alt="">
			<img class="ava_big" :src="state.avatar" alt="">
			<div class="arrow-rain arrow-rain_big" aria-hidden="true">
				<span></span>
				<span></span>
				<span></span>
			</div>
			<img @click="changePop" class="qrcode_big" :src="state.qr_code" alt="">


			<div class="p1_big">{{ state.time1 }}</div>
			<div class="p2_big">{{ state.time2 }}</div>

			<div class="p5_big">{{ state.tip }}</div>
			<div class="p6_big" @click="changePop2">【详情】</div>

			<div v-if="state.user_type==1" class="p3_1_big">{{ state.name }}</div>
			<div v-if="state.user_type==1" class="p4_1_big">{{ state.department }}</div>

			<div v-if="state.user_type==2" class="p3_big">{{ state.department }}</div>
			<div v-if="state.user_type==2" class="p4_big">{{ state.name }}</div>

			<div v-if="state.user_type==3" class="p3_3_big">{{ state.name }}</div>
			<div v-if="state.user_type==3" class="p4_3_big">{{ state.department }}</div>

			<!--		<div v-if="user_type==4" class="p3_4">{{}}</div>-->
			<div v-if="state.user_type==4" class="p4_4_big">{{ state.name }}</div>


		</div>
		<div v-show="state.show_pop" class="pop_mask">
			<div class="pop">
				<div class="pop_view">
					<img class="hd_img_pop" :src="state.qr_code" alt="">
				</div>
				<div class="btns2" @click="changePop">

					关闭
				</div>

			</div>

		</div>
		<div v-show="state.show_pop2" class="pop_mask">
			<div class="pop">
				<div class="pop_view">
					<div class="tip_view" v-html="state.tip21">
					</div>
				</div>
				<div class="btns2" @click="changePop2">

					关闭
				</div>

			</div>

		</div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref, onUnmounted, computed, watch } from 'vue';
import axios from '@/utils/request';
export default defineComponent({
  setup() {
    const state = reactive({
      userid: '',
      name: '',
      avatar: '',
      qr_code: '',
      department: '',
      time1: '',
      time2: '',

      show_pop: false,
      show_pop2: false,
      tip: `此电子工牌仅供使用者本人出入天津海信广场大楼核查使用，不得用于其他任何目的或用途，严禁转借、截图、录屏等...`,
      tip21: `<p style="text-align: center;">
            天津海信广场电子工牌使用细则
        </p>
        <p >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;此电子工牌仅供使用者本人出入天津海信广场大楼核查使用，不得用于其他任何目的或用途，严禁转借、截图、录屏等，离职自动失效。
        </p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;此电子工牌不代表使用者与天津海信广场有限公司构成任何事实上的劳动或劳务关系，或取得了天津海信广场有限公司的任何授权。
        </p>`,
      page_bg: '',
      page_bg_big: '',
      user_type: 0,
      page_type: 0,
    });
    const formattedDate = ref('');
    onMounted( ()=> {
      document.title = '电子工牌';
      const x = document.documentElement.clientHeight / document.documentElement.clientWidth;
      if (Math.floor(x * 10) > 17) {
        state.page_type = 2;
      } else {
        state.page_type = 1;
      }
      // 判断是否企微登录
      // if () {
        //  是企微登录调用执行代码
      // }
      state.url = Object.fromEntries(new URLSearchParams(decodeURIComponent(window.location.search)));
      if (state.url.code) {
        // 处理企微登录
        getConfig();
      } else {
        alert('请使用企业微信打开')
        return
      }
      updateFormattedDate();
      const interval = setInterval(updateFormattedDate, 1000); // 每秒钟更新一次
      // 在组件卸载时清除定时器
      onUnmounted(() => {
        clearInterval(interval);
      });
    });
    const pageBgUrl = computed(() => {
      if (state.page_type === 1) {
        switch (state.department) {
          case '百货销售顾问':
            return require('@/assets/resources/image/gp_bg7_1.png');
          case '生活方式组':
            return require('@/assets/resources/image/gp_bg7_3.png');
          case '生活超市':
            return require('@/assets/resources/image/gp_bg7_4.png');
          default:
            return require('@/assets/resources/image/gp_bg7_2.png');
        }
      } else {
        switch (state.department) {
          case '百货销售顾问':
            return require('@/assets/resources/image/gp_bg4_1.png');
          case '生活方式组':
            return require('@/assets/resources/image/gp_bg4_3.png');
          case '生活超市':
            return require('@/assets/resources/image/gp_bg4_4.png');
          default:
            return require('@/assets/resources/image/gp_bg4_2.png');
        }
      }
    });
    watch(
      () => state.department,
      (newValue) => {
        if (state.page_type === 1) {
          switch (newValue) {
            case '百货销售顾问':
              state.user_type = 1;
              break;
            case '生活方式组':
              state.user_type = 3;
              break;
            case '生活超市':
              state.user_type = 4;
              break;
            default:
              state.user_type = 2;
              break;
          }
        } else {
          switch (newValue) {
            case '百货销售顾问':
              state.user_type = 1;
              break;
            case '生活方式组':
              state.user_type = 3;
              break;
            case '生活超市':
              state.user_type = 4;
              break;
            default:
              state.user_type = 2;
              break;
          }
        }
      }
    );
    const getConfig = async () => {
      // 获取企微信息
      // 获取url 并且将url进行json解析 提取出code参数
      state.url = Object.fromEntries(new URLSearchParams(decodeURIComponent(window.location.search)));
      let code = state.url.code;
      const res = await axios.post('/sales/getsalesinfo_tianjin',{
        code: code,
      });
      if (res.data.code == 200) {
        state.department = res.data.result.department;
        state.avatar = res.data.result.avatar;
        state.qr_code = res.data.result.qrcode;
        state.userid = res.data.result.userid;
        state.name = res.data.result.name;
      }
    };
    const updateFormattedDate = () => {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      const second = date.getSeconds().toString().padStart(2, '0');
      state.time1 = `${year}/${month}/${day}`;
      state.time2 = `${hour}:${minute}:${second}`;
    };
    const changePop = () => {
      state.show_pop = !state.show_pop;
    };
    const changePop2 = () => {
      state.show_pop2 = !state.show_pop2;
    };
    return {
      state,
      formattedDate,
      changePop,
      changePop2,
      pageBgUrl,
    }
  },
})
</script>
<style>
:root {
  --viewport-width: 100vw;
  --viewport-height: 100vh;
}

/* 针对手机设备 */
@media (max-width: 767px) {
  .page {
    width: 100%;
    height: 100%;
  }

  .ava {
    width: 150px;
    height: 150px;
  }

  .p1 {
    font-size: 20px;
  }
}

/* 针对平板设备 */
@media (min-width: 768px) and (max-width: 1023px) {
  .page {
    width: 100%;
    height: 100%;
  }

  .ava {
    width: 200px;
    height: 200px;
  }

  .p1 {
    font-size: 25px;
  }
}

/* 针对桌面设备 */
@media (min-width: 1024px) {
  .page {
    width: 750px;
    height: 1470px;
  }

  .ava {
    width: 250px;
    height: 250px;
  }

  .p1 {
    font-size: 30px;
  }
}

/* 
	body {
		-webkit-text-size-adjust: 100% !important;

		width: 100vw;
		height: 100vh;
		box-sizing: border-box;
		font-size: 28px;
		padding: 0;
		margin: 0;
		border: 0;
	} */

	* {
		font-size: 28px;
		box-sizing: border-box;

	}

	.page {
		position: relative;
		width: 750px;
		height: 1470px;


	}

	.page_bg {
		position: absolute;
		left: 0;
		top: 0;
		width: 750px;
		height: 1206px;
	}

	.page_bg_big {
		position: absolute;
		right: 0;
		top: 0;
		/*width: 600px;*/
		/*height: 900px;*/
		width: 750px;
		height: 1470px;
	}

	.ava {
		position: absolute;
		left: 65px;
		top: 612px;
		width: 206px;
		height: 206px;
		border: 3px solid #ffffff;
	}

	.ava_big {
		position: absolute;
		left: 60px;
		top: 768px;
		width: 255px;
		height: 255px;
		border: 3px solid #ffffff;
	}

	.qrcode {
		position: absolute;
		left: 480px;
		top: 1074px;
		width: 100px;
		height: 100px;
		border-radius: 10px;
		border: 5px solid #ffffff;
	}

	.qrcode_big {
		position: absolute;
		left: 568px;
		top: 1280px;
		width: 120px;
		height: 120px;
		border-radius: 10px;
		border: 5px solid #ffffff;
	}

	.arrow-rain {
		position: absolute;
		left: 480px;
		top: 165px;
		width: 210px;
		height: 675px;
		overflow: hidden;
		pointer-events: none;
		z-index: 2;
	}

	.arrow-rain_big {
		left: 480px;
		top: 210px;
		height: 835px;
	}

	.arrow-rain span {
		position: absolute;
		left: 50%;
		bottom: -145px;
		display: block;
		width: 140px;
		height: 128px;
		opacity: 0;
		animation: arrowRainUp 5.1s ease-out infinite;
	}

	.arrow-rain span::before,
	.arrow-rain span::after {
		content: "";
		position: absolute;
		left: 50%;
		width: 76px;
		height: 76px;
		border-left: 16px solid rgba(0, 0, 0, .64);
		border-top: 16px solid rgba(0, 0, 0, .64);
		transform: translateX(-50%) rotate(45deg);
		filter: drop-shadow(0 0 12px rgba(255, 255, 255, .32));
	}

	.arrow-rain span::before {
		top: 0;
	}

	.arrow-rain span::after {
		top: 52px;
	}

	.arrow-rain span:nth-child(1) {
		animation-delay: 0s;
	}

	.arrow-rain span:nth-child(2) {
		animation-delay: 1.7s;
	}

	.arrow-rain span:nth-child(3) {
		animation-delay: 3.4s;
	}

	@keyframes arrowRainUp {
		0% {
			transform: translate(-50%, 70px) scale(.9);
			opacity: 0;
		}

		12% {
			opacity: .92;
		}

		62% {
			opacity: .72;
		}

		100% {
			transform: translate(-50%, -700px) scale(1.04);
			opacity: 0;
		}
	}


	.p1 {
		position: absolute;
		left: 575px;
		top: 60px;
		/* width: 110px;
		height: 110px; */
	}

	.p1_big {
		position: absolute;
		left: 560px;
		top: 96px;
		/* width: 110px;
		height: 110px; */
	}

	.p2 {
		position: absolute;
		left: 595px;
		top: 100px;
		/* width: 110px;
		height: 110px; */
	}

	.p2_big {
		position: absolute;
		left: 580px;
		top: 136px;
		/* width: 110px;
		height: 110px; */
	}

	.p3 {
		position: absolute;
		left: 69px;
		top: 830px;
		font-size: 30px;
		font-weight: bold;
	}

	.p3_big {
		position: absolute;
		left: 60px;
		top: 1030px;
		font-size: 40px;
		font-weight: bold;
	}

	.p3_1 {

		position: absolute;
		left: 70px;
		top: 863px;
		font-size: 65px;
		font-weight: bold;
		background: #ffb2b1;
	}

	.p3_1_big {
		position: absolute;
		left: 65px;
		top: 1080px;
		font-size: 65px;
		font-weight: bold;
		background: #ffb2b1;
	}

	.p3_3 {
		position: absolute;
		left: 63px;
		top: 890px;
		font-size: 65px;
		font-weight: bold;
		background: #ffef6a;

	}

	.p3_3_big {
		position: absolute;
		left: 63px;
		top: 1085px;
		font-size: 65px;
		font-weight: bold;
		background: #ffef6a;

	}

	.p3_4 {
		position: absolute;
		left: 63px;
		top: 1080px;
		font-size: 65px;
		font-weight: bold;
		background: #ffb2b1;

	}

	.p4 {
		position: absolute;
		left: 69px;
		top: 900px;
		width: 550px;
		font-size: 60px;
		font-weight: bold;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;

	}

	.p4_big {
		position: absolute;
		left: 60px;
		top: 1120px;
		width: 550px;
		font-size: 60px;
		font-weight: bold;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;

	}


	.p4_1 {
		position: absolute;
		left: 70px;
		top: 947px;
		font-size: 40px;
		font-weight: bold;
		background: #ffb2b1;
	}

	.p4_1_big {
		position: absolute;
		left: 65px;
		top: 1172px;
		font-size: 40px;
		font-weight: bold;
		background: #ffb2b1;
	}

	.p4_3 {
		position: absolute;
		left: 65px;
		top: 975px;
		font-size: 40px;
		font-weight: bold;
		background: #ffef6a;
	}

	.p4_3_big {
		position: absolute;
		left: 65px;
		top: 1177px;
		font-size: 40px;
		font-weight: bold;
		background: #ffef6a;
	}

	.p4_4 {
		position: absolute;
		left: 65px;
		top: 940px;
		font-size: 60px;
		font-weight: bold;
		background: #e9b3ff;
	}

	.p4_4_big {
		position: absolute;
		left: 65px;
		top: 1172px;
		font-size: 60px;
		font-weight: bold;
		background: #e9b3ff;
	}

	.p5 {
		position: absolute;
		left: 75px;
		top: 1085px;
		width: 380px;
		height: 90px;
		line-height: 25px;
		font-size: 20px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}

	.p5_big {
		position: absolute;
		left: 74px;
		top: 1290px;
		width: 460px;
		height: 100px;
		line-height: 30px;
		font-size: 22px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}

	.p6 {
		position: absolute;
		left: 370px;
		top: 1135px;
		font-size: 25px;
	}

	.p6_big {
		position: absolute;
		left: 440px;
		top: 1350px;
		font-size: 25px;
	}


	.pop_mask {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		z-index: 1000;
		background: rgba(0, 0, 0, .7);
		/*background: #0076ff;*/
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.pop {
		width: 750px;
		/*background: #da091c;*/
	}

	.pop_view {
		display: flex;
		justify-content: center;
	}

	.hd_img_pop {
		width: 500px;
		height: 500px;
	}

	.btns2 {
		/*position: absolute;*/
		/*bottom: 60px;*/
		/*left: 83px;*/
		margin-top: 50px;
		margin-left: 125px;
		margin-bottom: 50px;
		width: 500px;
		height: 70px;
		display: flex;

		align-items: center;
		justify-content: center;
		background: #ffffff;
		color: #000000;
	}

	.tip_view {
		width: 500px;
		padding: 30px;
		background: #ffffff;
	}

	.btnColor1 {
		background: #ffb0b1;
	}

	.btnColor2 {
		background: #7bf6d6;
	}

	.btnColor3 {
		background: #ffed67;
	}

	.btnColor4 {
		background: #e6b1ff;
	}
</style>